<template>
  <v-navigation-drawer
    app
    clipped
    hide-overlay
    :mini-variant="$vuetify.breakpoint.lgAndUp && !lock"
    v-model="internalValue"
    @input="$emit('input', internalValue)"
  >
    <v-list>
      <UserTile />
      <v-divider></v-divider>
      <!-- <v-list-tile v-if="isAuthenticated" @click="pushRoute('myEquipment')">
          <v-list-tile-action>
            <v-icon>assignment_ind</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ $t('navigation.myEquipment') }}</v-list-tile-title>
          </v-list-tile-content>
      </v-list-tile>-->
      <v-list-tile @click="pushRoute('allEquipment')">
        <v-list-tile-action>
          <v-icon>reorder</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ $t('navigation.allEquipment') }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile v-if="isAuthenticated" @click="pushRoute('workRequests')">
        <v-list-tile-action>
          <v-badge color="red">
            <template v-slot:badge>
              <span
                v-if="$store.getters.hasLatestWorkRequests && Number.isInteger($store.getters.hasLatestWorkRequests)"
                dark
                small
              >{{$store.getters.hasLatestWorkRequests}}</span>
              <v-icon v-else-if="$store.getters.hasLatestWorkRequests" dark small>notifications</v-icon>
            </template>
            <v-icon>speaker_notes</v-icon>
          </v-badge>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ $t('navigation.myWorkRequest') }}</v-list-tile-title>
        </v-list-tile-content>
        <!-- <v-list-tile-action>
            <v-btn icon slot="append" @click.stop="pushRoute('myEquipment')">
              <v-icon>add_box</v-icon>
            </v-btn>
        </v-list-tile-action>-->
      </v-list-tile>
      <!-- <v-list-tile v-if="isAuthenticated" @click="pushRoute('allinspections')">
        <v-list-tile-action>
          <v-icon>gamepad</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ $t('navigation.inspections') }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile> -->
      <v-divider></v-divider>
      <v-layout v-if="$route.name == 'equipment' && isAuthenticated" column>
        <v-list-tile
          v-for="(item, index) in navigationItems"
          :key="index"
          @click="goToHash(item.routerLinkData)"
        >
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
      </v-layout>
      <v-list-tile>
        <v-list-tile-action>
          <v-icon>language</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-layout row align-center justify-space-between>
            <v-btn
              v-for="entry in languages"
              :key="entry.title"
              @click="changeLocale(entry.language)"
              small
              style="min-width:10px;margin:0px;margin-right:5px;"
              :outline="isCurrentLocale(entry.language)"
            >{{entry.title}}</v-btn>
          </v-layout>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapActions } from 'vuex'
import { i18n } from '../i18n'
import UserTile from './UserTile'

export default {
  name: 'Navigation',
  components: {
    UserTile
  },
  props: {
    value: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      languages: [
        { flag: 'us', language: 'en', title: 'Eng' },
        { flag: 'ua', language: 'uk', title: 'Укр' }
      ],
      mini: false,
      internalValue: this.value
    }
  },
  computed: {
    lock() {
      return this.$store.getters.menuLock
    },
    loading() {
      return this.$store.state.base.loading
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
    user() {
      return this.$store.state.auth.user
    },
    navigationItems() {
      return this.$store.getters.navigationItems
    },
    error() {
      return this.$store.state.base.error
    }
  },
  watch: {
    value() {
      this.internalValue = this.value
    }
  },
  methods: {
    ...mapActions(['userSignOut', 'setCurrentLocale']),
    changeLocale(locale) {
      this.setCurrentLocale(locale)
      setTimeout(() => {
        this.internalValue = this.$vuetify.breakpoint.lgAndUp
      }, 500)
    },
    isCurrentLocale(locale) {
      return i18n.locale == locale
    },
    pushRoute(name) {
      this.$store.commit(
        'setNavigationDrawer',
        this.$vuetify.breakpoint.mdAndUp
      )
      this.$router.push({ name: name })
    },
    goToHash: function(hash) {
      this.$store.commit(
        'setNavigationDrawer',
        this.$vuetify.breakpoint.mdAndUp
      )
      var rand = Math.random()
      if (this.$route.query.equipmentId) {
        this.$router.push({
          path:
            this.$route.path +
            '?equipmentId=' +
            this.$route.query.equipmentId +
            '&rand=' +
            rand +
            '#' +
            hash
        })
      } else if (this.$route.params.equipmentId) {
        this.$router.push({
          path: this.$route.path + '?rand=' + rand + '#' + hash
        })
      } else {
        this.$router.push({ path: this.$route.path })
      }
    }
  }
}
</script>

<style>
/* button {
    padding: 5px;
    border: 1px solid green;
    font-size: 12px;
    margin: 3px;
} */
</style>
